import React from 'react';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

const enhance = compose(injectIntl);

const VehicleType = React.memo(({ intl, vehicle_type, axles }) => {
  const t = intl.messages;
  return t.vehicle_types[vehicle_type]
    ? t.vehicle_types[vehicle_type]
    : `${axles} ${t.driver_info_axles}`;
});

VehicleType.propTypes = {
  intl: PropTypes.object.isRequired,
  vehicle_type: PropTypes.string,
  axles: PropTypes.any,
};

export default enhance(VehicleType);
